module.exports = {
  familyName: 'Ubuntu',
  category: 'sans-serif',
  capHeight: 693,
  ascent: 932,
  descent: -189,
  lineGap: 28,
  unitsPerEm: 1000,
  xHeight: 520,
  xWidthAvg: 453
};
